import apiClient from "../apiClient";

export const UsersAPI = {
  getMyselfDetails: () => apiClient.get("/api/v1/employees/me/details"),
  getAllPaginated: ({ page, pageSize }) => {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
    });
    return apiClient.get(`/api/v1/employees?${params.toString()}`);
  },
};
